import { TextInput, required, BooleanInput } from 'react-admin';
import { FormBuilder } from './FormBuilder';

export const FormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={required()} />
    <BooleanInput source="active" />
    <TextInput
      source="emails"
      fullWidth
      label="Notify users"
      helperText="Comma-separated emails to notify when this form is completed"
    />
    <BooleanInput
      source="notify"
      label="Email customer the completed forms"
    />
    <FormBuilder
      source="formDefinition"
      label="Form definition"
      validate={[required()]}
    />
  </>
);
